import { Signal } from 'new-vait'

export const signal_critical_error = Signal<string>()
